export const GET_BOOK_REQUEST = "GET_BOOK_REQUEST";
export const GET_BOOK_SUCCESS = "GET_BOOK_SUCCESS";
export const GET_BOOK_FAILURE = "GET_BOOK_FAILURE";

export const CART_ADD = "CART_ADD";
